export const CONVERSION_PAGE_PATH = "/conversion-page";

export const SIGNUP_FORM_TOP_ID = "signup-form-top";

export const SIGNUP_FORM_BOTTOM_ID = "signup-form-bottom";

export function scrollToSignupForm() {
  const form = document.getElementById(SIGNUP_FORM_TOP_ID);
  if (form) {
    form.scrollIntoView({ behavior: "smooth" });
  }
}
